module.exports = __webpack_public_path__ + "img/ftp-icon.cc56e754.svg";